/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react'
import React from 'react'

import breakpoints from '../../utils/constants/breakpoints'

export const Thumb = ({ children, src, path, width, height, maxHeight, alt, type }) => {
  if (!src && !path) return false
  const style = css`
    min-width: ${width || '100%'};
    min-height: ${height};
    max-width: 100%;
    max-height: ${maxHeight || '100%'};
    background: url(${src});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    padding: 0.4rem;

    & > .content {
      padding: 2px;
      border-radius: 5px;
      background: #00000040;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 999;
      position: absolute;
    }
  `

  const video = css`
    min-width: ${width || '100%'};
    min-height: ${height};
    max-width: 100%;
    max-height: ${maxHeight || '100%'};
    border-radius: 5px;
    object-fit: cover;
  `

  return type === 'video' ? (
    <div css={style} alt={alt || src || path}>
      <video css={video} alt={alt || src || path} src={src || path}></video>
      {children && <div className="content">{children}</div>}
    </div>
  ) : (
    <div css={style} alt={alt || src || path} src={src || path}>
      {children && <div className="content">{children}</div>}
    </div>
  )
}

const generateFilter = ({ blur, grayscale, sepia }) => {
  if (!blur && !grayscale && sepia) return ''
  let filters = []
  if (blur === true) {
    filters.push('blur(.25rem)')
  } else if (!!blur) {
    filters.push(`blur(${blur})`)
  }
  if (sepia === true) {
    filters.push('sepia(90%)')
  }
  if (grayscale === true) {
    filters.push('grayscale(45%)')
  }

  return `filter: ${filters.join(' ')};`
}

const Image = ({ src, path, width, maxHeight, hideOnSmall, alt, frameColor, dashedFrame, blur, grayscale, sepia }) => {
  if (!src && !path) return false
  const style = css`
    display: block;
    max-width: ${width || '100%'};
    ${maxHeight ? `max-height: ${maxHeight};` : ''}
    ${generateFilter({ blur, grayscale, sepia })}
    ${frameColor &&
    `
			border: solid 2px ${frameColor};
			border-radius: 5px;
		`}
		${dashedFrame ? `border-style: dotted;` : ''}

		@media (max-width: ${breakpoints.md}px) {
      ${hideOnSmall ? 'display: none' : ''}
    }
  `

  return <img css={style} alt={alt || src || path} src={src || path} />
}

export const BGImage = ({
  src,
  path,
  padding,
  width,
  height,
  maxHeight,
  hideOnSmall,
  alt,
  frameColor,
  dashedFrame
}) => {
  if (!src && !path) return false
  const style = css`
    padding: ${padding};
    max-width: ${width || '100%'};
    ${height ? `height: ${height};` : ''}
    ${maxHeight ? `max-height: ${maxHeight};` : ''}
			${frameColor
      ? `
			border: solid 2px ${frameColor};
			border-radius: 5px;
		`
      : ''}
		${dashedFrame ? `border-style: dotted;` : ''} 

		@media (max-width: ${breakpoints.md}px) {
      ${hideOnSmall ? 'display: none' : ''}
    }

    & > .img {
      width: 100%;
      height: 100%;
      background: url(${src});
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
    }
  `

  return (
    <div css={style} className="bgImage">
      <div className="img" />
    </div>
  )
}

export default Image
